import React from 'react';
import { FieldFactory, FieldTypes } from '@sitecore-jss/sitecore-jss-react-forms';

import { Dropdown, MultiLineText, RadioButtonList, SingleLineText, SubmitButton, Text } from './FormElement';

const customFieldFactory = new FieldFactory();

customFieldFactory.setComponent(FieldTypes.RadioButtonList, props => <RadioButtonList {...props} />);
customFieldFactory.setComponent(FieldTypes.TextField, props => <Text {...props} />);
customFieldFactory.setComponent(FieldTypes.MultipleLineText, props => <MultiLineText {...props} />);
customFieldFactory.setComponent(FieldTypes.SingleLineText, props => <SingleLineText {...props} />);
customFieldFactory.setComponent(FieldTypes.DropdownList, props => <Dropdown {...props} />);
customFieldFactory.setComponent(FieldTypes.Button, props => <SubmitButton {...props} />);

export default customFieldFactory;
